module.exports = " <div v-show=content class=wrap :style=\"{'line-height':h,'height':h,'width':w}\" _v-623082ba=\"\"> <div style=\"position: relative;\ndisplay: inline-block;\nline-height: 1.8\" _v-623082ba=\"\"> <div class=bg _v-623082ba=\"\"><span _v-623082ba=\"\">{{content}}</span></div> <div class=content _v-623082ba=\"\"><span _v-623082ba=\"\">{{content}}</span></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-623082ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/toast.vue
// module id = 415
// module chunks = 31